var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pgrid rootContainer",class:[
    'tabKey_' +
      (this.$store.state.pgridVars != null && this.$store.state.pgridVars.TabKey != null
        ? this.$store.state.pgridVars.TabKey.replaceAll('-', '_')
        : 'unknown') ],attrs:{"id":"pgrid-root-container"}},[_c('pgrid-filters'),_vm._v(" "),_c('pgrid-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }